import { Create, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { StaffScheduleFormFields } from './StaffScheduleForm';

export const StaffScheduleCreate = () => (
  <Create redirect="list">
    <SimpleForm
      toolbar={<MyToolbar resource="userGroupOrganization" />}
      defaultValues={{ is_primary: 0 }}
    >
      <MyFormContainer>
        <StaffScheduleFormFields isCreate />
      </MyFormContainer>
    </SimpleForm>
  </Create>
);

export default StaffScheduleCreate;
